import Module from '@/store/resource/common/module';
import CustomObjects from '@/store/resource/customObjects';
import api from '@/factories/api';
let module = new Module(new CustomObjects());

module.add('actions', {
  async fetchStandaloneObjects({ commit }) {
    try {
      const res = await api().get('custom/objects?standalone=true');
      const standaloneObjects = (res || []).filter((obj) => obj.standalone);
      commit('setStandaloneObjects', standaloneObjects);
    } catch (err) {
      throw err;
    }
  },
  async loadStandaloneObject({ state, commit }, objectId) {
    const existing = state.standaloneObjects.find((obj) => obj.id === objectId);
    if (existing) return;

    try {
      const obj = await api().get(`custom/objects/${objectId}?standalone=true`);
      if (obj) {
        commit('setStandaloneObjects', [...state.standaloneObjects, obj]);
      }
    } catch (err) {
      throw err;
    }
  },
  async loadRecordsCount({ commit }, objectId) {
    if (!objectId) return 0;

    const params = { obj_id: objectId, page: 1, per_page: 1 };
    const data = await api().get('custom/records', { params });
    const count = data?.count || 0;

    commit('setRecordsCount', { objectId, count });
    return count;
  },
});

module.add('mutations', {
  setStandaloneObjects(state, objects) {
    state.standaloneObjects = objects;
  },
  setRecordsCount(state, { objectId, count }) {
    state.recordsCountCache = {
      ...state.recordsCountCache,
      [objectId]: count,
    };
  },
});

module.add('state', {
  standaloneObjects: [],
  recordsCountCache: {},
});

module.add('getters', {
  isStandaloneObject: (state) => (objectId) => {
    return state.standaloneObjects.some((obj) => obj.id === objectId);
  },
  getStandaloneObject: (state) => (objectId) => {
    return state.standaloneObjects.find((obj) => obj.id === objectId);
  },
  getRecordsCount: (state) => (objectId) => {
    return state.recordsCountCache[objectId] || 0;
  },
});

export default module.create();
